// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mtlgyjbzdbqzptdzkjyb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im10bGd5amJ6ZGJxenB0ZHpranliIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkzNzY2OTYsImV4cCI6MjA1NDk1MjY5Nn0.sS9z0XFO4p7ROHgi1PhJaK8fJkx6z9Yq81AXVWEeN3A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// flowType: 'pkce' is required for native (iOS/Android) Google sign-in — see
// src/utils/nativeAuth.ts, which completes the session via exchangeCodeForSession
// and needs the redirect URL to carry a `code` param, not implicit-flow tokens.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    flowType: 'pkce',
  },
});